<template>
  <div id="GoodsModule">
    <div class="goods-module">
<!--      <div v-for="item in goodsList" :key="item.id" class="goods-card" @click="goDetail(item)">-->
<!--        <div class="goods-img">-->
<!--          <img :src="getFileUrl(item.supplierCompanyLogo) || '/noimage.png'" class="img">-->
<!--        </div>-->
<!--        <div class="item_name">-->
<!--          <div class="name">-->
<!--            <a-popover :content="item.supplierCompanyName">{{ item.supplierCompanyName }}</a-popover>-->
<!--          </div>-->
<!--          <div class="name">联系人：{{ item?.supplierCompanyContacts?.[0] || '' }}</div>-->
<!--          <div class="name">联系电话：{{ item.supplierCompanyPhone?.[0] || '' }}</div>-->
<!--          <div class="name">积分商品数量：{{ item.pointsGoodsNumber }}</div>-->
<!--          <div class="name"><a-popover :content="`${ item.minPoints }-${ item.maxPoints }积分`">积分兑换范围：{{ item.minPoints }}-{{ item.maxPoints }}积分</a-popover></div>-->
<!--        </div>-->
<!--&lt;!&ndash;        <div class="item_price">&ndash;&gt;-->
<!--&lt;!&ndash;          <span class="price">{{ item.points }}</span><span>积分</span>&ndash;&gt;-->
<!--&lt;!&ndash;          <a-icon type="shopping-cart" @click.stop="addCart(item)"/>&ndash;&gt;-->
<!--&lt;!&ndash;        </div>&ndash;&gt;-->
<!--      </div>-->
<!--      <a-empty style="margin: 50px auto 0" v-if="!goodsList.length"/>-->
<!--    </div>-->
      <!-- 公司卡片区域 -->
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">合作企业</h2>
        </div>

        <div class="companies-grid">
          <!-- 第一行卡片 -->
          <div class="company-card" v-for="item in goodsList" :key="item.id" @click="goDetail(item)">
            <div class="card-header">
              <div class="company-logo"
                   :style="{ 'background': 'url('+ getFileUrl(item.supplierCompanyLogo || '') +')', 'background-size': 'cover'}"
              >
              </div>
              <div class="company-info">
                <div class="company-name">
                  <a-popover :content="item.supplierCompanyName">{{ item.supplierCompanyName }}</a-popover>
                </div>
                <div class="company-contact">
                  <i><img src="@/assets/icon/my.png" style="width: 17px;margin-bottom: 4px;" /></i>
                  <span>{{ item?.supplierCompanyContacts?.[0] || '' }}</span>
                </div>
                <div class="company-contact">
                  <i><img src="@/assets/icon/phone.png" style="width: 17px;margin-bottom: 4px;" /></i>
                  <span>{{ item.supplierCompanyPhone?.[0] || '' }}</span>
                </div>
              </div>
            </div>
            <div class="card-body">
<!--              <p>提供企业级云服务解决方案，助力数字化转型</p>-->
              <p>{{ item.supplierCompanyAddress }}</p>
              <div class="exchange-info">
                <div class="points">
                  <i><img src="@/assets/icon/jifen2.png" style="width: 17px;margin-bottom: 4px;" /></i>
                  {{ item.minPoints }}-{{ item.maxPoints }}
                </div>
                <div class="stock">数量: {{ item.pointsGoodsNumber }}</div>
              </div>
              <button class="exchange-btn">立即兑换</button>
            </div>
          </div>
          <a-empty style="margin: 50px auto 0" v-if="!goodsList.length"/>
        </div>
      </div>
    </div>
    <div class="pagination">
      <a-pagination :total="total" :defaultPageSize="8" @change="paginationChange"/>
    </div>
  </div>
</template>
<script>
import {insertCart} from "@/api/mall";
import fileUrlMixin from "@/mixins/fileUrlMixin";

export default {
  mixins: [fileUrlMixin],
  props: {
    goodsList: {
      type: Array,
      required: true
    },
    total: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
    }
  },
  methods: {
    paginationChange (current) {
      this.$emit('paginationChange', current)
    },
    goDetail (item) {
      this.$router.push({
        path: `/shopDetail`,
        query: {
          id: item.supplierCompanyId,
          name: item.supplierCompanyName,
          supplierCompanyLogo: item.supplierCompanyLogo,
          phone: item.supplierCompanyPhone?.[0] || '',
          person: item?.supplierCompanyContacts?.[0] || ''
        }
      })
    },
    addCart (item) {
      insertCart({goodsId: item.id, count: 1}).then(res => {
        if (!res.code) {
          this.$message.success('加入成功')
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
/* 内容区域样式 */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 40px 0 20px;
}

.section-title {
  font-size: 28px;
  font-weight: 700;
  color: #2c3e50;
  position: relative;
  padding-bottom: 10px;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 60px;
  height: 4px;
  background: linear-gradient(90deg, #ff9a9e, #fad0c4);
  border-radius: 2px;
}

.filter-options {
  display: flex;
  gap: 15px;
}

/* 公司卡片样式 */
.companies-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 25px;
  margin-bottom: 40px;
}

.company-card {
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
  transition: all 0.4s ease;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.company-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}

.card-header {
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 15px;
  border-bottom: 1px solid #f0f4f8;
}

.company-logo {
  width: 60px;
  height: 60px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 24px;
  font-weight: bold;
  flex-shrink: 0;
}

.company-info {
  flex: 1;
}

.company-name {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 5px;
  color: #2c3e50;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 170px;
}

.company-contact {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #7f8c8d;
  margin-top: 5px;
}

.company-contact i {
  color: #a1c4fd;
}

.card-body {
  padding: 20px;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.card-body p {
  color: #7f8c8d;
  margin-bottom: 15px;
  max-height: 42px;              /* 设置最大高度 */
  overflow: hidden;               /* 隐藏超出部分的内容 */
  text-overflow: ellipsis;        /* 使用省略号显示溢出的文本 */
  display: -webkit-box;           /* 必须使用 Webkit box 显示多行文本 */
  -webkit-line-clamp: 2;          /* 设置显示的行数，这里是3行 */
  -webkit-box-orient: vertical;   /* 设置排列方向为纵向 */
}

.exchange-info {
  display: flex;
  justify-content: space-between;
  margin-top: auto;
  padding-top: 15px;
}

.points {
  font-weight: 700;
  color: #e74c3c;
  font-size: 18px;
}

.points i {
  margin-right: 5px;
  color: #ffd700;
}

.stock {
  background-color: #f0f8ff;
  color: #3498db;
  padding: 5px 12px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
}

.exchange-btn {
  //background: linear-gradient(135deg, #84fab0, #8fd3f4);
  background: linear-gradient(135deg, #a1c4fd, #c2e9fb);
  //color: #2c3e50;
  color: white;
  border: none;
  padding: 12px 0;
  width: 100%;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 15px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
}

.exchange-btn:hover {
  opacity: 0.9;
  transform: translateY(-3px);
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1);
}
/*
  --------------------------------------
*/

.goods-module{
  display: flex;
  flex-wrap: wrap;
  min-height: 250px;
  //gap: 30px;
  gap: 30px;
}
.goods-card:hover{
  box-shadow: 0 2px 10px 0 rgba(0,0,0,.2);
}
.goods-card{
  //width: 230px;
  width: 216px;
  padding: 15px 10px;
  cursor: pointer;
  border-radius: 8px;
  box-shadow: 0 2px 10px 0 rgba(0,0,0,.1);
  .goods-img {
    width: 100%;
    //height: 230px;
    //line-height: 230px;
    height: 156px;
    line-height: 156px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    .img {
      max-width: 100%;
      max-height: 100%;
    }
  }
  .item_name{
    margin: 10px 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    .name {
      height: 30px;
      //overflow: hidden;
      //display: -webkit-box;
      //-webkit-box-orient: vertical;
      //-webkit-line-clamp: 2;
      line-height: 20px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 100%
    }
  }
  .item_price{
    color: #333333;
    .price{
      font-size: 22px;
      font-weight: 550;
      margin-right: 5px;
      color: #de0000;
    }
    .anticon-shopping-cart{
      float: right;
      font-size: 24px;
    }
    .anticon{
    }
  }
}
.pagination{
  margin: 20px 0;
  padding: 10px;
  display: flex;
  justify-content: center;
}
</style>
